import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {NotificationService} from "./services/repositories/notification.service";
import {filter, take} from "rxjs";
import { AuthService } from './services/repositories/auth.service';
import { AppInitService } from './services/internals/app-init.service';
import { Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit{
  token: any;
  currentUrl: any;
  path: any = [];
  i: number = 0;
  j: number = 0;
  comptePartage: any;
  
  constructor(
    public notifService: NotificationService,
    private cdRef: ChangeDetectorRef,
    public router: Router,
    public authService: AuthService,
    public appInitService: AppInitService,
    private platform: Platform,
  ) {
    this.currentUrl = this.router.url.split('?')[0];
    console.log(this.currentUrl);
    
    this.listenGoogleAuthRedirect();
    this.listenNotificationLinks();
    this.appInitService.handleInitialNavigation();
  }

  listenGoogleAuthRedirect() {
    this.platform.ready().then(() => {
      // Ecoute le deep link
      App.addListener('appUrlOpen', (data: any) => {
        console.log('Deep link reçu :', data.url);

        if (data.url.startsWith('grooveplan://home')) {
          const url = new URL(data.url);
          const state = url.searchParams.get('state');

          if (state) {
            // Récupération des tokens
            this.authService.getGoogleAuthTokensIdsFromState(state).then((req: any) => {
              req.pipe(take(1)).subscribe({
                next: (res: any) => {
                  this.authService.handleAuthSuccess(res).then(() => {
                    this.router.navigate(['']);
                  })
                },
                error: (err: any) => {
                  console.error(err);
                }
              })
            })
          }

          // Fermer le navigateur si encore ouvert
          Browser.close();
        }
      });
    });
  }

  listenNotificationLinks() {
    this.notifService.redirectLink$.subscribe(link => {
      if (link) {
        this.router.navigate([link]);
        this.notifService.redirectLink.next(null);
      }
    });
  }

  ngOnInit() {
    this.authService.comptePartage$.subscribe(value => {
      this.comptePartage = value;
      this.cdRef.detectChanges(); // au cas où le changement vient d’un autre composant
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentUrl = this.router.url.split('?')[0];
    });

    
  }

  
}